import {host} from "~/utils/constants";
export class Reference {
    id = 0;
    title = "";
    content = {}
    description = ""
    image = {id:0,url:""}

    // Rehydrate a plain object into a Reference instance
    static fromJSON(obj: Partial<Reference>): Reference {
        return Object.assign(new Reference(), obj)
    }

    parseJson(ret: { id: number; attributes: { [key: string]: any } }) {
        this.id = ret.id;
        this.image = ret.attributes.image.data ? {
            url:host+ret.attributes.image.data.attributes.url,
            id:ret.attributes.image.data.id
        } : {id:-1, url:""};
        this.title = ret.attributes.title;
        this.content = ret.attributes.content;
        this.description = ret.attributes.description;
    }
    toJSON () {
        return {
            ...this
        } // here I make a POJO's copy of the class instance
    }
    toApiJSON(){
        return {
            ...this,
            imageUrl : null,
            image: this.image.id >= 0 ? this.image.id : null
        } // here I make a POJO's copy of the class instance
    }
}
